// Floating clones of attackers mid-lunge. Rendered via portal to
// document.body so the keyframe's vertical bleed (-60 / +60 px) can
// extend past the Field's `overflow-x: auto` clip into the surrounding
// margin / phase-divider seam.

import { createPortal } from "react-dom";
import { motion } from "motion/react";
import { Card } from "../Card";
import type { pixelTheme } from "../../theme/pixel";
import type { LungeItem } from "../../logic/useBattleAnimations";
import { combatLungeKeyframes, combatLungeTransition } from "../../logic/motion";

export function CombatLungeOverlay({
  items,
  theme,
  onComplete,
}: {
  items: ReadonlyArray<LungeItem>;
  theme: typeof pixelTheme;
  onComplete: (eid: number) => void;
}) {
  if (items.length === 0) return null;
  return createPortal(
    <>
      {items.map((it) => (
        <motion.div
          key={it.eid}
          initial={{ y: 0, scale: 1, rotate: 0 }}
          animate={combatLungeKeyframes(it.direction)}
          transition={combatLungeTransition()}
          onAnimationComplete={() => onComplete(it.eid)}
          style={{
            position: "fixed",
            left: it.rect.left,
            top: it.rect.top,
            width: it.rect.width,
            height: it.rect.height,
            zIndex: 1500,
            pointerEvents: "none",
            margin: 0,
          }}
        >
          <Card card={it.card} size="small" theme={theme} />
        </motion.div>
      ))}
    </>,
    document.body,
  );
}
